import { Dialog } from "@headlessui/react"
import { useEffect, useState } from "react"
import { SongSelection } from "../../../../../types"
import { KButton, KInput, KSpan, KTitleSpan } from "kahuna-base-react-components"

const SongSelectionOwnershipUpdateModal = ({
  songSelection,
  setSongSelection,
  onSubmit,
  loading
}: {
  songSelection: SongSelection | undefined
  setSongSelection: (songSelection: SongSelection | undefined) => void
  onSubmit: (songSelectionId: number, ownership: number) => Promise<void>
  loading: boolean
}) => {
  const onClose = () => {
    setSongSelection(undefined)
  }

  const [ownership, setOwnership] = useState<number>(0)

  useEffect(() => {
    if (songSelection) {
      setOwnership(songSelection.ownership)
    } else {
      setOwnership(0)
    }
  }, [songSelection])

  return (
    <Dialog open={songSelection !== undefined} onClose={() => onClose()}>
      <div className="fixed w-screen h-screen top-0 left-0 z-250 flex items-center justify-center bg-[#0000004d] ">
        <div className="p-6 shadow-md rounded-[10px] bg-[#fff]" style={{ maxHeight: "600px", overflowY: "scroll" }}>
          <div>
            <KTitleSpan fontSize={20} lineHeight="22px" text="Update Split Rate" />
          </div>

          <div>
            <div className="flex flex-row gap-2 items-center mt-5">
              <KSpan text="Split Rate:" color="#000" fontWeight={500} />
              <KInput
                type="number"
                placeholder="Split Rate"
                value={String(ownership)}
                onChange={(text: string) => {
                  setOwnership(Number(text))
                }}
              />
            </div>
          </div>
          <div className="flex gap-3 mt-8 justify-center items-center">
            <KButton text={"Cancel"} onClick={() => onClose()} background="#fff" shadowDisabled={true} />
            <KButton
              text={"Submit"}
              textColor="white"
              background="black"
              onClick={() => {
                if (!(songSelection && songSelection?.id) || loading) return
                onSubmit(songSelection.id, ownership)
              }}
              disabled={ownership === null || ownership === undefined || songSelection === undefined || !songSelection?.id || loading}
            />
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default SongSelectionOwnershipUpdateModal
